const sortByLabel = (options = []) =>
	[...options].sort((a, b) =>
		String(a.label ?? "").localeCompare(String(b.label ?? ""), undefined, {
			sensitivity: "base",
		})
	);

export const resolveCompanyOfficeLabel = (office, officeTypes = []) => {
	const directName =
		office?.CompanyOfficeName?.trim() || office?.OfficeName?.trim();
	if (directName) {
		return directName;
	}

	const officeType = officeTypes.find(
		(type) => Number(type.OfficeTypeId) === Number(office?.OfficeTypeId)
	);

	if (officeType?.OfficeTypeName) {
		const prefix = office?.EmployeeCodePrefix?.trim();
		return prefix
			? `${officeType.OfficeTypeName} (${prefix})`
			: officeType.OfficeTypeName;
	}

	return `Office ${office?.CompanyOfficeId ?? ""}`.trim();
};

export const buildCompanyOfficeSelectOptions = (masterData) => {
	const officeTypes = (masterData?.OfficeTypeMaster || []).filter(
		(type) => type.DataStatus === 1
	);

	return sortByLabel(
		(masterData?.CompanyOfficeMaster || [])
			.filter((office) => office.DataStatus !== 0)
			.map((office) => ({
				label: resolveCompanyOfficeLabel(office, officeTypes),
				value: office.CompanyOfficeId,
			}))
	);
};

export const getCompanyOfficeDisplayName = (item, masterData) => {
	if (item?.CompanyOfficeName?.trim()) {
		return item.CompanyOfficeName.trim();
	}

	const officeTypes = (masterData?.OfficeTypeMaster || []).filter(
		(type) => type.DataStatus === 1
	);
	const matchedOffice = (masterData?.CompanyOfficeMaster || []).find(
		(office) =>
			String(office.CompanyOfficeId) === String(item?.CompanyOfficeId)
	);

	if (matchedOffice) {
		return resolveCompanyOfficeLabel(matchedOffice, officeTypes);
	}

	if (item?.OfficeTypeName) {
		return item.OfficeTypeName;
	}

	return "No Office Assigned";
};
